import styled from "styled-components";
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";

export const ProjectsSectionContainer = styled.div`
  width: 100%;
  background-color: ${COLORS.Crimson};
  border-radius: ${BORDER_RADIUS.radius24};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding-bottom: ${SIZE.max120};
  }
`;

export const ProjectsSectionWrapper = styled.div`
  height: auto;
  z-index: 5;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  max-width: 2000px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    flex-direction: column;
    height: auto;
  }
`;

export const CirclesWrapper = styled.div`
  z-index: 1;
`;

export const ProjectsSectionDescriptionContainer = styled.div`
  padding: ${SIZE.max120} ${SIZE.max80};
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max65};
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ProjectsSectionTextWrapper = styled.div`
  height: auto;
`;

export const ProjectsSectionTitleWrapper = styled.div``;

export const ProjectsSectionSubtitleWrapper = styled.div``;

export const ProjectsSectionDescriptionWrapper = styled.div`
  padding: ${SIZE.max24} 0;
`;

export const ProjectsSectionButtonWrapper = styled.div``;

export const ProjectsSectionCarouselContainer = styled.div`
  width: calc(90% - ${SIZE.max550});
  margin: ${SIZE.max80} 0;
  height: 100%;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 80%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    margin: 0;
  }
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max84};
`;
export const ArticleTitleWrapper = styled.div`
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: row;
  width: 90%;
  padding-right: 80px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    margin-bottom: 8px;
    gap: 12px;
    width: 100%;
  }
`;
export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max220};
    width: ${SIZE.max220};
  }
`;
